import {CSSTransition} from "react-transition-group";
import * as React from "react";
import * as FocusTrap from "focus-trap-react";
import FullPostModalData from "../../../data/FullPostModalData";
import {observer} from "mobx-react";
import {FullPostModal} from "./FullPostModal";

/**
 * A modal component that relies on FullPostModalData
 *
 * @constructor
 */
export const FullPostModalContainer = observer(() => {
    return (
        <CSSTransition
          classNames="page"
          timeout={250}
          in={FullPostModalData.showFullPostModal}
        >
          <section>
            {FullPostModalData.post && <div aria-modal={true}>
              <FocusTrap focusTrapOptions={
                {
                  allowOutsideClick: false,
                  clickOutsideDeactivates: true,
                  // onPostActivate: () => {
                  //   console.log('Focus Trap onPostActivate')
                  // },
                  // onActivate: () => {
                  //   console.log('Focus Trap onActivate')
                  // },
                  // onDeactivate: () => {
                  //   console.log('Focus Trap onDeactivate');
                  // },
                  // onPostDeactivate: () => {
                  //   console.log('Focus Trap onPostDeactivate')
                  // },
                }
              }>
                <div className={"full-post-modal-wrapper"}>
                  <FullPostModal key="required_by_transition_group" />
                </div>
              </FocusTrap>
            </div>
            }
          </section>
        </CSSTransition>
    );
});
